// extracted by mini-css-extract-plugin
export default {"container":"BN-z","topReviewHeading":"CN-z","criticalReview":"DN-z","favorableReview":"EN-z","vsSeparator":"FN-z"};